import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {react} from "mobx";
import {
    FormGroup, Form,
    Input,
    Label,
    Row, Col
} from 'reactstrap'
import 'moment/locale/pt-br';

import DetalhesLotePagamentoStore from "../stores/DetalhesLotePagamentoStore";
import DataWrapper from "../../principal/containers/DataWrapper";
import {sortAlphaNum} from "../../../utils/ordenar";
import {formatarValorReal, formatarDataISO8601, ordenarData} from "../../../utils/formatar";
import {Tabela} from "../../comum/components/Tabela";

@inject("store")
@DataWrapper
@observer
export class DetalhesLotePagamento extends Component {

    constructor(props) {
        super(props);

        this.appState = this.props.store.appState;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.formStore = this.props.store.formStore;
        this.modalStore = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.loginStore = this.props.store.loginStore;


        this.controller = new DetalhesLotePagamentoStore();
    }

    componentWillMount() {
        this.controller.loadDetalhes(_.get(this.props, "match.params.idLote"));
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Lote de pagamento #"+_.get(this.props, "match.params.idLote"));
    }

    render() {
        const COLUNAS = [
            {
                field: "cpf",
                label: "CPF",
                mobileWidth: 100
            },{
                field: "nomeCompleto",
                label: "Nome",
                mobileWidth: 200
            },{
                field: "nomeGestor",
                label: "Gestor",
                mobileWidth: 200
            },{
                field: "cargo",
                label: "Cargo",
                mobileWidth: 160
            },{
                field: "competencia",
                label: "Competência",
                mobileWidth: 120
            },{
                field: "solicitacaoId",
                label: "Solicitação",
                mobileWidth: 120
            },{
                field: "valorTotal",
                label: "Valor",
                dataFormat: formatarValorReal,
                funcaoOrdenacao: sortAlphaNum.bind("valorTotal"),
                mobileWidth: 160
            },{
                field: "dataAdmissao",
                label: "Admissão",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataAdmissao"),
                mobileWidth: 100
            },{
                field: "dataTermino",
                label: "Término",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataTermino"),
                mobileWidth: 100
            }
        ];

        const acoesItens = [];

        acoesItens.push({
            tipo: "visualizar",
            label: "Visualizar",
            icone: "search-plus",
            cor: "text-info",
            parametro: "timesheetId",
            acao: "/detalhes-lote-pagamento/timesheet"
        });

        return (
            <div>
                <div className="form-wrapper">
                    <Form className="panel-form">
                        <h4>Nota fiscal</h4>
                        <Row>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Número</Label>
                                    <Input type="text" value={this.controller.numeroNotaFiscal} readOnly/>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Data de emissão</Label>
                                    <Input type="textF" value={this.controller.dataEmissaoNotaFiscal} readOnly/>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Data de vencimento</Label>
                                    <Input type="text" value={this.controller.dataVencimentoNotaFiscal} readOnly/>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Série</Label>
                                    <Input type="text" value={this.controller.serieNotaFiscal} readOnly/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <h4>Pagamento</h4>
                        <Row>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Lote</Label>
                                    <Input type="text" value={this.controller.lote} readOnly/>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Unidade de negócio (BU)</Label>
                                    <Input type="textF" value={this.controller.nomeEmpresaGlobo} readOnly/>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Valor total (R$)</Label>
                                    <Input type="text" value={this.controller.valorTotal} readOnly/>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label>Data de geração</Label>
                                    <Input type="text" value={this.controller.dataGeracao} readOnly/>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                    <h4>MOTs</h4>
                    <Tabela
                        keyField={"cpf"}
                        habilitarSelecaoMultipla={false}
                        listaItens={this.controller.mots}
                        colunas={COLUNAS}
                        temBusca={false}
                        acoesItens={acoesItens}
                        onChange={(value) => this.controller.setLista(value)}
                        loading={this.controller.loading}
                        colunaOrdenacaoPadrao={"cpf"}
                        />
                </div>
            </div>
        );
    }
}
